import type { HierarchyRectangularNode } from 'd3-hierarchy';

import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import { DEFAULT_FILL_OPACITY } from '../../core/constants.js';
import { getOpacity } from '../../core/utils/getOpacity.js';
import type {
  HighlightingMap,
  InternalTreeMapNode,
} from '../types/internal.js';

export const getNodeOpacity = (
  entry: HierarchyRectangularNode<InternalTreeMapNode>,
  highlightingMap: HighlightingMap,
  highlightedItem?: LegendItem,
): number => {
  const hasHighlightedItem = highlightedItem !== undefined;

  if (!hasHighlightedItem) {
    return DEFAULT_FILL_OPACITY;
  }

  const isHighlighted = highlightingMap[entry.data.id].has(
    highlightedItem.name,
  );

  return getOpacity(isHighlighted);
};
